import React, { useState, useEffect, useRef } from 'react'; 
import './scss/puzztime.scss';


import { initializeApp } from "firebase/app";
import { getAnalytics,logEvent } from "firebase/analytics";

import { BrowserRouter, Routes, Route, Link, useLocation, useNavigate  } from 'react-router-dom';

import SelecJuego from './components/SelecJuego';
import LateralJuegos from './components/LateralJuegos';
import juegos from './assets/juegos.json';



/**
 * Ionic Dark Mode
 * -----------------------------------------------------
 * For more info, please see:
 * https://ionicframework.com/docs/theming/dark-mode
 */

/* import '@ionic/react/css/palettes/dark.always.css'; */
/* import '@ionic/react/css/palettes/dark.class.css'; */
//import '@ionic/react/css/palettes/dark.system.css';

/* Theme variables */
//import './theme/variables.css';

//setupIonicReact();




/*const App: React.FC = () => (
  <div>
    <h2>Parejas</h2>
    <img src="public/iconos/caballo.png"/>
    <Carta></Carta>
  </div>
);*/
function ListaJuegos() {

     const navigate = useNavigate();

  const firebaseConfig = {
  apiKey: "AIzaSyCceVPpjBFbA_khqjXABlFtdex6wU6YWPM",
  authDomain: "everyday---deia.firebaseapp.com",
  projectId: "everyday---deia",
  storageBucket: "everyday---deia.firebasestorage.app",
  messagingSenderId: "789110585317",
  appId: "1:789110585317:web:5d01114092fe374edce10c",
  measurementId: "G-N0EC1VFRC5"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);


function Menu(){
    document.getElementById("lateral-juegos")!.style.left = "0px";
    document.getElementById("lateral-juegos")!.style.boxShadow = "4px 0 20px rgba(0,0,0,0.08)";
    document.getElementById("lateral-overlay")!.style.opacity = "1";
    document.getElementById("lateral-overlay")!.style.pointerEvents = "auto";
}


  

function ClickJuego(juego: string){
    navigate("/"+juego+"/0");
  }

  

  




 return (
    <div className="puzztime home">
      <header className="topbar topbar--home">
      <button className="game-topbar__btn game-topbar__btn--back" aria-label="Volver"  onClick={()=>Menu()} >
          
          <img className="botonMenu" src="./iconos/menu_desplegable.png" />
        </button>
          <div className="divTitulo">
              <h1 className="tituloJuegos" ><img className="logoDeia" src="./title_juegos.png" alt="Juegos" /></h1>
          </div>
      </header>
      <div className="home-content">
        <p className="fraseHome">Ya están preparados tus puzzles de hoy gracias a <a href="https://puzztime.com" target="_blank" rel="noopener nofollow" className="puzztime-link">Puzztime!</a><br></br>Tómate un respiro y disfruta</p>

        <div className="homeJuegos">
        {juegos.map((juego, i) => (
                  <SelecJuego nombre={juego.nombre}  frase={juego.frase} idJuego={juego.id} icono={juego.icono} color={juego.color} clicked={() => ClickJuego(juego.escena)}></SelecJuego>
                ))}
        </div>
      </div>

    </div>


  )
}

export default ListaJuegos;
